<template>
  <chip :payload="payload" />
</template>

<script>
import PrepareChipMixin from '@/app/arch/mixins/PrepareChipMixin';
import Chip from 'Arch/components/global-components/Chip.vue';

export default {
  name: 'DataTableChipColumn',
  components: { Chip },
  mixins: [PrepareChipMixin],
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    status: [],
  }),
  computed: {
    getStatus() {
      return this.prepareStatus.find(
        (status) => status.value === this.value,
      );
    },
    payload() {
      return this.prepare(this.getStatus);
    },
    prepareStatus() {
      return this.formatContent(
        this.status,
      );
    },
  },
  methods: {
    handleStatus(status) {
      return this.formatContent(status);
    },
  },
};
</script>
